<template>
  <v-dialog v-model="$confirm.opened.value" persistent max-width="400px">
    <v-card class="pb-2">
      <v-toolbar
        v-if="$confirm.state.color"
        dense
        :color="$confirm.state.color"
      >
        <v-toolbar-title>{{ $confirm.state.title }} </v-toolbar-title>
      </v-toolbar>
      <v-card-title v-else>{{ $confirm.state.title }} </v-card-title>
      <v-card-text v-if="$confirm.state.content" class="mt-4">
        {{ $confirm.state.content }}
      </v-card-text>
      <v-card-actions
        :class="$confirm.state.content ? 'mt-4 pl-4' : 'mt-8 pl-4'"
      >
        <v-btn
          v-if="!Array.isArray($confirm.state.confirmText)"
          :color="$confirm.state.color"
          class="mr-4"
          variant="tonal"
          @click="$confirm.confirm()"
          >{{ $confirm.state.confirmText }}</v-btn
        ><span v-else>
          <v-btn
            v-for="(text, i) in $confirm.state.confirmText"
            :key="i"
            :color="$confirm.state.color"
            class="mr-4"
            :variant="i === 0 ? 'tonal' : 'outlined'"
            @click="$confirm.confirm(i)"
            >{{ text }}</v-btn
          >
        </span>
        <v-btn variant="outlined" @click="$confirm.cancel">{{
          $confirm.state.cancelText
        }}</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { useConfirmStore } from "@/store/confirm";

const $confirm = useConfirmStore();
</script>
